module.exports = __webpack_public_path__ + "img/SoccerBG.7a05afb6.jpg";